// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.previewContainer_M59Cr {
  position: fixed;
  background-color: white;
  z-index: 9999;
  width: 400px;
  max-height: 800px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  -webkit-user-select: none;
          user-select: none;
  transition: box-shadow 0.2s ease;
  resize: none;
  top: 20px;
  right: 20px;
}

.previewContainer_M59Cr:hover {
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
}

.previewContainer_M59Cr.fullscreen_rXViN {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  border-radius: 0;
  max-width: none;
  min-height: none;
}

.previewHeader_BaZkI {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #12ad87 0%, #16be96 100%);
  color: white;
  padding: 6px 4px;
  cursor: move;
  -webkit-user-select: none;
  user-select: none;
}

.previewHeader_BaZkI:active {
  cursor: grabbing;
}

.previewTitle_n3zuW {
  margin: 0;
  font-size: 0.875rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.previewActions_lvm9t {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.actionButton_pNM3M {
  width: 28px;
  height: 28px;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  transition: all 0.2s ease;
  color: white;
}

.actionButton_pNM3M:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

.previewStatus_ymat8 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.successStatus_vlmxW {
  color: #16be96;
  padding: 1px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  border: 1px solid #16be96;
}

.errorStatus_bbEOW {
  background: rgba(244, 67, 54, 0.2);
  color: #f44336;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  border: 1px solid rgba(244, 67, 54, 0.3);
}

.loadingStatus_PK0AN {
  background: rgba(255, 193, 7, 0.2);
  color: #ffc107;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  border: 1px solid rgba(255, 193, 7, 0.3);
}

.autoUpdateStatus_L81r5 {
  background: rgba(33, 150, 243, 0.2);
  color: #2196f3;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  border: 1px solid rgba(33, 150, 243, 0.3);
}

.successStatus_vlmxW {
  background: rgba(22, 190, 150, 0.2);
  color: #16be96;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  border: 1px solid rgba(22, 190, 150, 0.3);
}

.previewContent_aqGJm {
  height: calc(100% - 40px);
  overflow: hidden;
  position: relative;
}

.previewFrame_IjnEj {
  width: 100%;
  height: 100%;
  border: none;
  background: white;
}

.loadingOverlay_eEu23 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.loadingSpinner_rQjjD {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #16be96;
  border-radius: 50%;
  animation: spin_auKZM 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin_auKZM {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.errorDisplay_ipShc {
  padding: 20px;
  background: #fee;
  border: 1px solid #fcc;
  border-radius: 8px;
  margin: 16px;
  color: #c33;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 14px;
  line-height: 1.4;
  max-height: 300px;
  overflow-y: auto;
}

.errorDisplay_ipShc h4 {
  margin: 0 0 12px 0;
  color: #a00;
}

.errorDisplay_ipShc pre {
  background: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
  overflow-x: auto;
  margin: 8px 0;
  font-size: 12px;
  line-height: 1.3;
  white-space: pre-wrap;
  word-break: break-word;
}

.errorHelp_gYaJ1 {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #fcc;
}

.errorHelp_gYaJ1 p {
  margin: 0 0 8px 0;
  font-weight: 600;
}

.errorHelp_gYaJ1 ul {
  margin: 0;
  padding-left: 20px;
}

.errorHelp_gYaJ1 li {
  margin: 4px 0;
  font-size: 13px;
}

.previewInfo_AIzYK {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: rgba(22, 190, 150, 0.1);
  color: #16be96;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  border: 1px solid rgba(22, 190, 150, 0.2);
}

/* Resizers */
.resizer_kRFkV {
  position: absolute;
  background: transparent;
  z-index: 1001;
}

.resizerLeft_bqZr3 {
  left: -2px;
  top: 0;
  width: 4px;
  height: 100%;
  cursor: w-resize;
}

.resizerRight_JcBDf {
  right: -2px;
  top: 0;
  width: 4px;
  height: 100%;
  cursor: e-resize;
}

.resizerTop_geZDN {
  top: -2px;
  left: 0;
  width: 100%;
  height: 4px;
  cursor: n-resize;
}

.resizerBottom_rH_NK {
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 4px;
  cursor: s-resize;
}

.resizerTopLeft_tNRXR {
  top: -2px;
  left: -2px;
  width: 8px;
  height: 8px;
  cursor: nw-resize;
}

.resizerTopRight_J0xjJ {
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  cursor: ne-resize;
}

.resizerBottomLeft_nDl43 {
  bottom: -2px;
  left: -2px;
  width: 8px;
  height: 8px;
  cursor: sw-resize;
}

.resizerBottomRight_lPbfl {
  bottom: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  cursor: se-resize;
}

/* Hover effects para resizers */
.resizer_kRFkV:hover {
  background: rgba(22, 190, 150, 0.3);
}

/* Responsive */
@media (max-width: 768px) {
  .previewContainer_M59Cr {
    width: 90vw;
    height: 70vh;
    left: 5vw !important;
    top: 15vh !important;
  }
  
  .previewContainer_M59Cr.fullscreen_rXViN {
    width: 100vw;
    height: 100vh;
    left: 0 !important;
    top: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/ChatView/FileExplorer/ReactPreview.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,gCAAgC;EAChC,YAAY;EACZ,SAAS;EACT,WAAW;AACb;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,wCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,wDAAwD;EACxD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yCAAyC;AAC3C;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,MAAM;EACN,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,MAAM;EACN,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,mCAAmC;AACrC;;AAEA,eAAe;AACf;EACE;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iBAAiB;EACnB;AACF","sourcesContent":[".previewContainer {\n  position: fixed;\n  background-color: white;\n  z-index: 9999;\n  width: 400px;\n  max-height: 800px;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n  overflow: hidden;\n  user-select: none;\n  transition: box-shadow 0.2s ease;\n  resize: none;\n  top: 20px;\n  right: 20px;\n}\n\n.previewContainer:hover {\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);\n}\n\n.previewContainer.fullscreen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 9999;\n  border-radius: 0;\n  max-width: none;\n  min-height: none;\n}\n\n.previewHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: linear-gradient(135deg, #12ad87 0%, #16be96 100%);\n  color: white;\n  padding: 6px 4px;\n  cursor: move;\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n.previewHeader:active {\n  cursor: grabbing;\n}\n\n.previewTitle {\n  margin: 0;\n  font-size: 0.875rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.previewActions {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.actionButton {\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  transition: all 0.2s ease;\n  color: white;\n}\n\n.actionButton:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.05);\n}\n\n.previewStatus {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.successStatus {\n  color: #16be96;\n  padding: 1px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  border: 1px solid #16be96;\n}\n\n.errorStatus {\n  background: rgba(244, 67, 54, 0.2);\n  color: #f44336;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 500;\n  border: 1px solid rgba(244, 67, 54, 0.3);\n}\n\n.loadingStatus {\n  background: rgba(255, 193, 7, 0.2);\n  color: #ffc107;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 500;\n  border: 1px solid rgba(255, 193, 7, 0.3);\n}\n\n.autoUpdateStatus {\n  background: rgba(33, 150, 243, 0.2);\n  color: #2196f3;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 500;\n  border: 1px solid rgba(33, 150, 243, 0.3);\n}\n\n.successStatus {\n  background: rgba(22, 190, 150, 0.2);\n  color: #16be96;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 500;\n  border: 1px solid rgba(22, 190, 150, 0.3);\n}\n\n.previewContent {\n  height: calc(100% - 40px);\n  overflow: hidden;\n  position: relative;\n}\n\n.previewFrame {\n  width: 100%;\n  height: 100%;\n  border: none;\n  background: white;\n}\n\n.loadingOverlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.9);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n}\n\n.loadingSpinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #16be96;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 16px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.errorDisplay {\n  padding: 20px;\n  background: #fee;\n  border: 1px solid #fcc;\n  border-radius: 8px;\n  margin: 16px;\n  color: #c33;\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n  font-size: 14px;\n  line-height: 1.4;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.errorDisplay h4 {\n  margin: 0 0 12px 0;\n  color: #a00;\n}\n\n.errorDisplay pre {\n  background: #f5f5f5;\n  padding: 12px;\n  border-radius: 4px;\n  overflow-x: auto;\n  margin: 8px 0;\n  font-size: 12px;\n  line-height: 1.3;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.errorHelp {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid #fcc;\n}\n\n.errorHelp p {\n  margin: 0 0 8px 0;\n  font-weight: 600;\n}\n\n.errorHelp ul {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.errorHelp li {\n  margin: 4px 0;\n  font-size: 13px;\n}\n\n.previewInfo {\n  position: absolute;\n  bottom: 8px;\n  right: 8px;\n  background: rgba(22, 190, 150, 0.1);\n  color: #16be96;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  border: 1px solid rgba(22, 190, 150, 0.2);\n}\n\n/* Resizers */\n.resizer {\n  position: absolute;\n  background: transparent;\n  z-index: 1001;\n}\n\n.resizerLeft {\n  left: -2px;\n  top: 0;\n  width: 4px;\n  height: 100%;\n  cursor: w-resize;\n}\n\n.resizerRight {\n  right: -2px;\n  top: 0;\n  width: 4px;\n  height: 100%;\n  cursor: e-resize;\n}\n\n.resizerTop {\n  top: -2px;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  cursor: n-resize;\n}\n\n.resizerBottom {\n  bottom: -2px;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  cursor: s-resize;\n}\n\n.resizerTopLeft {\n  top: -2px;\n  left: -2px;\n  width: 8px;\n  height: 8px;\n  cursor: nw-resize;\n}\n\n.resizerTopRight {\n  top: -2px;\n  right: -2px;\n  width: 8px;\n  height: 8px;\n  cursor: ne-resize;\n}\n\n.resizerBottomLeft {\n  bottom: -2px;\n  left: -2px;\n  width: 8px;\n  height: 8px;\n  cursor: sw-resize;\n}\n\n.resizerBottomRight {\n  bottom: -2px;\n  right: -2px;\n  width: 8px;\n  height: 8px;\n  cursor: se-resize;\n}\n\n/* Hover effects para resizers */\n.resizer:hover {\n  background: rgba(22, 190, 150, 0.3);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .previewContainer {\n    width: 90vw;\n    height: 70vh;\n    left: 5vw !important;\n    top: 15vh !important;\n  }\n  \n  .previewContainer.fullscreen {\n    width: 100vw;\n    height: 100vh;\n    left: 0 !important;\n    top: 0 !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"previewContainer": `previewContainer_M59Cr`,
	"fullscreen": `fullscreen_rXViN`,
	"previewHeader": `previewHeader_BaZkI`,
	"previewTitle": `previewTitle_n3zuW`,
	"previewActions": `previewActions_lvm9t`,
	"actionButton": `actionButton_pNM3M`,
	"previewStatus": `previewStatus_ymat8`,
	"successStatus": `successStatus_vlmxW`,
	"errorStatus": `errorStatus_bbEOW`,
	"loadingStatus": `loadingStatus_PK0AN`,
	"autoUpdateStatus": `autoUpdateStatus_L81r5`,
	"previewContent": `previewContent_aqGJm`,
	"previewFrame": `previewFrame_IjnEj`,
	"loadingOverlay": `loadingOverlay_eEu23`,
	"loadingSpinner": `loadingSpinner_rQjjD`,
	"spin": `spin_auKZM`,
	"errorDisplay": `errorDisplay_ipShc`,
	"errorHelp": `errorHelp_gYaJ1`,
	"previewInfo": `previewInfo_AIzYK`,
	"resizer": `resizer_kRFkV`,
	"resizerLeft": `resizerLeft_bqZr3`,
	"resizerRight": `resizerRight_JcBDf`,
	"resizerTop": `resizerTop_geZDN`,
	"resizerBottom": `resizerBottom_rH_NK`,
	"resizerTopLeft": `resizerTopLeft_tNRXR`,
	"resizerTopRight": `resizerTopRight_J0xjJ`,
	"resizerBottomLeft": `resizerBottomLeft_nDl43`,
	"resizerBottomRight": `resizerBottomRight_lPbfl`
};
export default ___CSS_LOADER_EXPORT___;
